<template>
  <div class="main-page wap">
    <Header></Header>
    <Banner></Banner>
    <Carousel :isSelf="true"></Carousel>
    <div class="m-wap-page page-bottom">
      <List></List>
    </div>
  </div>
</template>
<script>
//import Vue from "vue";
import Header from "../../components/Header";
// import Column from "../../components/Column.vue";
import Banner from "../../components/Banner.vue";
import List from "../../components/Wap/List.vue";
import Carousel from "../../components/Wap/Carousel.vue";
//import { $subscriber } from "fire-wind-water";
// import $ from "jquery";

export default {
  name: "Article",
  data() {
    return {};
  },
  components: {
    Header,
    // Column,
    Banner,
    List,
    Carousel
  },
  created() {
    //    $subscriber.subscribe("config-loaded", res=>{
    //      this.page = res.page;
    //      // $('body').css('background-color',this.page.backgroundColor.value)
    //      window.$sk.loading.hide();
    //    });
  }
};
</script>
